class PaginationComponent extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this.render();
  }

  static get observedAttributes() {
    return ['current-page', 'total-pages'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (oldValue !== newValue) {
      this.render();
    }
  }

  render() {
    const style = `
      <style>
        .pagination {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 8px;
        }

        .pagination__btn {
          min-width: 48px;
          height: 48px;
          padding: 0;
          border-radius: 50%;
          background: #EDEEF4;
          color: #3D3D3D;
          border: none;
          font-size: 14px;
          font-weight: 500;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.2s;

          &:hover {
            background: #000;
            color: #fff;
          }
        }

        .pagination__btn:disabled {
          cursor: not-allowed;
          opacity: 0.5;
        }

        .pagination__btn:hover:not(:disabled) {
          border-color: #1790FF;
        }

        .pagination__btn.active {
          background: #000;
          color: #fff;
          border-color: #000;
        }

        @media (max-width: 767px) {
          .pagination__btn {
            min-width: 32px;
            height: 32px;
            border: 1px solid #cacaca;
            color: #999;
            background: #fff;

            &.active {
              background: #000;
              color: #fff;
              border-color: #000;
            }
          }
        }
      </style>
    `;

    const currentPage = parseInt(this.getAttribute('current-page')) || 1;
    const totalPages = parseInt(this.getAttribute('total-pages')) || 1;

    const buttons = [];

    // 上一页按钮
    buttons.push(`
      <button 
        class="pagination__btn" 
        data-page="${currentPage - 1}"
        ${currentPage <= 1 ? 'disabled' : ''}
      >
        &lt;
      </button>
    `);

    // 页码按钮
    const maxVisiblePages = window.matchMedia(GkifyTheme.config.mediaQueryMobile).matches ? 3 : 5;
    const startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    const endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (startPage > 1) {
      buttons.push(`<span class="pagination__ellipsis">...</span>`);
    }

    for (let i = startPage; i <= endPage; i++) {
      buttons.push(`
        <button 
          class="pagination__btn ${i === currentPage ? 'active' : ''}" 
          data-page="${i}"
        >
          ${i}
        </button>
      `);
    }

    if (endPage < totalPages) {
      buttons.push(`<span class="pagination__ellipsis">...</span>`);
    }

    // 下一页按钮
    buttons.push(`
      <button 
        class="pagination__btn" 
        data-page="${currentPage + 1}"
        ${currentPage >= totalPages ? 'disabled' : ''}
      >
        &gt;
      </button>
    `);

    this.shadowRoot.innerHTML = `
      ${style}
      <div class="pagination" part="pagination">
        ${buttons.join('')}
      </div>
    `;

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.shadowRoot.querySelectorAll('.pagination__btn').forEach((btn) => {
      if (!btn.disabled) {
        btn.addEventListener('click', () => {
          const page = parseInt(btn.dataset.page);
          // 触发自定义事件
          this.dispatchEvent(
            new CustomEvent('page-change', {
              detail: { page },
              bubbles: true,
              composed: true,
            })
          );
        });
      }
    });
  }
}

customElements.define('pagination-component', PaginationComponent);
